import React from 'react';

function StepBar({ active = 1 }) {
  return (
    <div className="flex items-center justify-center mb-6 w-full">
      <div className={`flex flex-col items-center justify-center rounded-md flex-1 h-14 z-10 ${active >= 1 ? 'bg-[#ffb200]' : 'bg-gray2'}`}>
        <div className={`${active >= 1 ? 'text-white' : 'text-gray'} text-xl font-bold`}>1</div>
        <div className={`${active >= 1 ? 'text-white' : 'text-gray'} text-sm font-bold`}>基本資料</div>
      </div>
      <div
        className={`w-0 h-0 border-l-[8px] ${active >= 1 ? 'border-l-[#ffb200]' : 'border-l-gray2'}`}
        style={{ margin: '0 -1px', borderBottom: '8px solid transparent', borderTop: '8px solid transparent' }}
      />
      <div className={`flex flex-col items-center justify-center text-white text-3xl rounded-md flex-1 h-14 z-10 ${active >= 2 ? 'bg-[#ff9c00]' : 'bg-gray2'}`}>
        <div className={`${active >= 2 ? 'text-white' : 'text-gray'} text-xl font-bold`}>2</div>
        <div className={`${active >= 2 ? 'text-white' : 'text-gray'} text-sm font-bold`}>確認資料</div>
      </div>
      {/* <div className={`w-0 h-0 border-l-[8px] ${active >= 2 ? 'border-l-[#ff9c00]' : 'border-l-gray2'}`} style={{ margin: '0 -1px', borderBottom: '8px solid transparent', borderTop: '8px solid transparent' }} />
      <div className={`flex flex-col items-center justify-center text-white text-3xl rounded-md flex-1 h-14 z-10 ${active >= 3 ? 'bg-[#ff8a00]' : 'bg-gray2'}`}>
        <div className={`${active >= 3 ? 'text-white' : 'text-gray'} text-xl font-bold`}>3</div>
        <div className={`${active >= 3 ? 'text-white' : 'text-gray'} text-sm font-bold`}>本人認證</div>
      </div> */}
      <div
        className={`w-0 h-0 border-l-[8px] ${active >= 3 ? 'border-l-[#ff8a00]' : 'border-l-gray2'}`}
        style={{ margin: '0 -1px', borderBottom: '8px solid transparent', borderTop: '8px solid transparent' }}
      />
      <div className={`flex flex-col items-center justify-center text-white text-3xl rounded-md flex-1 h-14 z-10 ${active >= 4 ? 'bg-[#ff7700]' : 'bg-gray2'}`}>
        <div className={`${active >= 4 ? 'text-white' : 'text-gray'} text-xl font-bold`}>3</div>
        <div className={`${active >= 4 ? 'text-white' : 'text-gray'} text-sm font-bold`}>申請完成</div>
      </div>
    </div>
  );
}

export default StepBar;
